import marked from 'marked'
import store from '@sb/store'
import Emoji from '../components/Emoji.js'

var sb = require('@sb/util')

export default {
	name: 'TextMessage',
	props: ['ev'],

	data () {
		return { sendError: false }
	},

	created () {
		this.checkSendError()
	},

	render () {
		var format = sb.get(this.ev, 'data.message.format', 'plaintext')
		if (format === 'markdown') return this.renderMarkdown()

		var text = sb.get(this.ev, 'data.message.text')
		if (sb.size(text) === 0) return null

		let byType = sb.get(this.ev, 'by.type')

		var tags = sb.extractText(text).map(tag => {
			if (tag.type === 'emoji') return <Emoji emojiCode={tag.text} byType={byType} />
			if (tag.type === 'link') return <a href={tag.text} target='_blank'>{tag.text}</a>
			if (tag.type === 'phone') return <a href={'tel:' + tag.text}>{tag.text}</a>
			if (tag.type === 'email') return <a href={'mailto:' + tag.text}>{tag.text}</a>
			return tag.text
		})

		if (byType === 'agent') {
			return (
				<div>
					<div class="message-agent message-text--agent">{tags}</div>
				</div>
			)
		}

		return (
			<div class="d-flex flex-column align-items-end">
				<div class={`message-user message-text--user ${this.sendError ? 'message-text--error' : ''}`}>{tags}</div>
				{this.sendError ? (
					<div class="red">
						<a src="javascript:;" vOn:click={this.resendMessage}>
							{this.$t('error_send_message')}
						</a>
					</div>
				) : null}
			</div>
		)
	},

	methods: {
		renderMarkdown () {
			var text = sb.get(this.ev, 'data.message.text')
			if (sb.size(text) === 0) return null

			let byType = sb.get(this.ev, 'by.type')

			if (byType === 'agent') {
				return (
					<div class="markdown-message message-agent message-text--agent">
						<div domPropsInnerHTML={marked(text)}></div>
					</div>
				)
			}

			return (
				<div class="d-flex flex-column align-items-end">
					<div
						class={`markdown-message message-user message-text--user ${this.sendError ? 'message-text--error' : ''}`}>
					<div domPropsInnerHTML={marked(text)}></div>
					</div>
					{this.sendError ? (
						<div class="red">
							<a src="javascript:;" vOn:click={this.resendMessage}>
								{this.$t('error_send_message')}
							</a>
						</div>
					) : null}
				</div>
			)
		},

		async resendMessage () {
			let convoKey = sb.convoKeyOfEv(this.ev)
			const message = {
				text: sb.get(this.ev, 'data.message.text'),
				format: 'plaintext',
			}

			await store.sendConvoEvent(convoKey, message)
		},

		checkSendError () {
			if (this.ev.id !== sb.getMsgField(this.ev, 'idempotency')) {
				this.sendError = false
				return
			}
			// sending
			let created = sb.getMs(sb.get(this.ev, 'created'))
			// timeout: 60 seconds
			if (new Date().getTime() - created > 60 * 1000) this.sendError = true
			else {
				this.sendError = false
				setTimeout(() => {
					this.checkSendError()
				}, 60 * 1000)
			}
		},
	},
}
